module.exports = __webpack_public_path__ + "static/media/employee_banner.ad2450b8.png";